<template>
  <div class="order-detail">
    <div class="order-detail-info">
      <div class="order-detail-header">
        <h5 class="order-title">
          {{ BasicData.Title }}
        </h5>

        <span class="order-des">
          提交人:
          {{ SubmitUserInfo.UserName }}
          {{ BasicData.SubmitTime2 }}
          <span class="order-tel">
            <!-- <i class="el-icon-phone-outline"></i
            ><a :href="`tel:${BasicData.SubmitUserPhone}`">{{
              BasicData.SubmitUserPhone
            }}</a> -->
            <i class="el-icon-phone-outline"></i>{{
              BasicData.SubmitUserPhone
            }}
          </span>
        </span>
      </div>

      <div class="order-detail-box">
        <div
          class="order-detail-boxshadow"
          v-if="$route.query.type === 'normal'"
        >
          <div class="order-detail-list">
            <div class="order-detail-item">
              <span> 工单ID </span>
              <span>
                {{ BasicData.Id }}
              </span>
            </div>
            <div class="order-detail-item">
              <span> 关联工单 </span>
              <span>
                <span @click="goDetail(BasicData.ref_work_id)">
                  {{ BasicData.ref_work_id }}
                </span>
                <el-button
                  type="primary"
                  size="mini"
                  @click="selectPopupShow('association')"
                >选择</el-button>
              </span>
            </div>
            <div class="order-detail-item">
              <span> 业务类型 </span>
              {{ BasicData.WorkTypeName }}

              <span>
              </span>
            </div>
            <div class="order-detail-item">
              <span> 业务分类 </span>
              <span>
                {{ BasicData.CategoryName }}

              </span>
            </div>
            <div
              class="order-detail-item"
              v-if="$route.query.type !== 'complaint'"
            >
              <span> 处理组 </span>
              <span>
                {{
                  orderInfo.ProcessGroupsAll.map((item) => item.GroupName).join(
                    ","
                  )
                }}
              </span>
            </div>
            <div class="order-detail-item">
              <span> 渠道来源 </span>
              <span>
                {{ BasicData.ChannelName }}
              </span>
            </div>
            <div class="order-detail-item">
              <span> 客户类型 </span>
              <span>
                {{ BasicData.ContactRelation }}
              </span>
            </div>
            <div class="order-detail-item">
              <span> 客户姓名 </span>
              <span>
                {{ BasicData.ContactName }}
                {{
                  hisPatientEnumsMap.lst_member_grade_map &&
                  hisPatientEnumsMap.lst_member_grade_map[
                    BasicData.CustomerLevel
                  ]
                }}
              </span>
            </div>
            <contactPhone :BasicData="BasicData" />
            <!-- <div class="order-detail-item">
              <span> 联系电话 </span>
              <span class="order-item-connect">
                <div>
                  {{ BasicData.ContactPhone }}
                </div>
                <div>
                  <el-link
                    icon="el-icon-folder-opened"
                    :underline="false"
                    @click="goCallRecords"
                  >通话记录</el-link>
                  <el-link
                    v-show="BasicData.ContactPhone"
                    icon="el-icon-phone-outline"
                    :underline="false"
                    @click="contactClients"
                  >联系客户</el-link>
                </div>
              </span>
            </div> -->
            <div class="order-detail-item">
              <span> 患者证件号 </span>
              <span class="order-item-connect">
                <div>
                  {{ BasicData.kehu_id_type_name }} {{ BasicData.kehu_id_no }}
                </div>
                <div>
                  <el-link
                    icon="el-icon-sunrise"
                    :underline="false"
                    @click="goRights"
                  >查看权益</el-link>
                  <el-link
                    icon="el-icon-edit-outline"
                    :underline="false"
                    @click="showIdForm"
                  ></el-link>
                </div>
              </span>
            </div>
            <div
              class="order-detail-item"
              v-if="BasicData.WorkType === 'pd1'"
            >
              <span> PD-1权益 </span>
              <span class="order-item-connect">
                <div class="order-item-connect-pd1">
                  <div>
                    <el-link
                      icon="el-icon-notebook-2"
                      :underline="false"
                      @click="goPd1Rights('handbook')"
                    >服务手册</el-link>
                    <el-link
                      icon="el-icon-star-off"
                      :underline="false"
                      @click="goPd1Rights('detail')"
                    >权益详情</el-link>
                  </div>
                  <div>
                    <el-link
                      icon="el-icon-notebook-2"
                      :underline="false"
                      @click="goPd1Rights('means')"
                    >客户资料</el-link>
                    <el-link
                      icon="el-icon-notebook-2"
                      :underline="false"
                      @click="goPd1Rights('flow')"
                    >服务进度</el-link>
                  </div>
                  <div v-if="BasicData.pd1_card_version === '垫付版'">
                    <el-link
                      icon="el-icon-notebook-2"
                      :underline="false"
                      @click="goPd1Rights('pharmacyMaintenance')"
                    >药房查询</el-link>
                  </div>
                </div>
              </span>
            </div>
            <div
              class="order-detail-item"
              v-if="BasicData.WorkType === 'pd1'"
            >
              <span> PD-1标签 </span>
              <span>
                {{ pd1EnumsMap.service_label && pd1EnumsMap.service_label[BasicData.pd1_label] }}
              </span>
            </div>
            <!-- <div
              class="order-detail-item"
              v-if="BasicData.customerStatusName"
            >
              <span> {{ BasicData.customerStatusName }} </span>
              <span>
                <span @click="goDetail(BasicData.ref_work_id)">
                  {{ BasicData.ref_work_id }}
                </span>
                <el-button
                  type="primary"
                  size="mini"
                  @click="goCustomerStatus"
                >查看详情</el-button>
              </span>
            </div> -->
            <div
              class="order-detail-item"
              v-if="BasicData.menzhen_work_id_neijing"
            >
              <span> 内镜状态 </span>
              <span>
                <span @click="goDetail(BasicData.ref_work_id)">
                  {{ BasicData.ref_work_id }}
                </span>
                <el-button
                  type="primary"
                  size="mini"
                  @click="goCustomerStatus('neijing')"
                >查看详情</el-button>
              </span>
            </div>
            <div
              class="order-detail-item"
              v-if="BasicData.menzhen_work_id_neijing"
            >
              <span> 内镜服务日志 </span>
              <span>

                <el-button
                  type="primary"
                  size="mini"
                  @click="goCustomerLogs('neijing')"
                >查看详情</el-button>
              </span>
            </div>
            <div
              class="order-detail-item"
              v-if="BasicData.menzhen_work_id_tijian"
            >
              <span> 体检状态 </span>
              <span>
                <span @click="goDetail(BasicData.ref_work_id)">
                  {{ BasicData.ref_work_id }}
                </span>
                <el-button
                  type="primary"
                  size="mini"
                  @click="goCustomerStatus('tijian')"
                >查看详情</el-button>
              </span>
            </div>
            <div
              class="order-detail-item"
              v-if="BasicData.menzhen_work_id_tijian"
            >
              <span> 体检服务日志 </span>
              <span>

                <el-button
                  type="primary"
                  size="mini"
                  @click="goCustomerLogs('tijian')"
                >查看详情</el-button>
              </span>
            </div>
          </div>
        </div>
        <complaintWorkInfo
          v-else
          @workMyWorkDetail="workMyWorkDetail"
          :BasicData="BasicData"
          :userInfo="userInfo"
        />
        <div class="order-detail-boxshadow">
          <p class="order-describe-key">{{ $route.query.type === 'complaint' ? '投诉详情' : '工单描述' }}：</p>
          <p
            class="order-describe-value"
            v-html="BasicData.Notes"
          ></p>
          <div
            class="order-detail-btn-waisong"
            v-if="BasicData.CategoryId == 98"
          >
            <!-- <div class="order-detail-btn-waisong"> -->
            <el-button
              type="primary"
              size="mini"
              @click="goAppDetails"
            >查看预约详情</el-button>
            <el-button
              type="primary"
              size="mini"
              @click="showDeliveryTime()"
            >外送时间</el-button>
          </div>
        </div>
        <div
          class="order-detail-boxshadow"
          v-if="$route.query.type === 'normal'"
        >
          <div class="order-detail-list">
            <div class="order-detail-item">
              <span> 受理组：{{ BasicData.AcceptGroupName }} </span>
              <span>
                <el-button
                  v-if="BasicData.WorkType !== 'sell_new' && BasicData.WorkType !== 'kanzhenyuyue'"
                  type="primary"
                  size="mini"
                  @click="selectPopupShow('acceptanceGroup')"
                >分配受理组</el-button>
              </span>
            </div>
            <div class="order-detail-item">
              <span> 受理人：{{ BasicData.AcceptUserName }} </span>
              <span>
                <el-button
                  type="primary"
                  size="mini"
                  @click="selectPopupShow('assignee')"
                >更改受理人</el-button>
              </span>
            </div>
            <div class="order-detail-item">
              <span> 标签：{{ tagMap[BasicData.work_label] }} </span>
              <span>
                <el-button
                  type="primary"
                  size="mini"
                  @click="selectPopupShow('tag')"
                >标签</el-button>
              </span>
            </div>
            <div
              class="order-detail-item"
              v-if="BasicData.WorkType == 'pd1'"
            >
              <span> 服务标签：{{ tagMap[BasicData.work_label] }} </span>
              <span>
                <el-button
                  type="primary"
                  size="mini"
                  @click="selectPopupShow('serviceType')"
                >标签</el-button>
              </span>
            </div>
            <div class="order-detail-item">
              <span> 转发人：{{ BasicData.ForwardUserName }} </span>
              <span>
                <el-button
                  type="primary"
                  size="mini"
                  @click="sendBack"
                >退回</el-button>
              </span>
            </div>
            <div
              class="order-detail-item"
              v-if="BasicData.ExternalType === 'fangaixian' && BasicData.work_label"
            >
              <span> 服务信息 </span>
              <span>
                <el-button
                  type="primary"
                  size="mini"
                  @click="fangaiEdit"
                >编辑</el-button>
              </span>
            </div>
          </div>
        </div>
        <complaintWorkAction
          v-else
          @workMyWorkDetail="workMyWorkDetail"
          :BasicData="BasicData"
          :userInfo="userInfo"
        />
        <div class="order-detail-boxshadow">
          <p class="order-describe-key">
            <span>附件：</span>
            <span v-if="
                orderInfo.IsUserCopy ||
                orderInfo.IsUserProcess ||
                orderInfo.IsUserSubmit ||
                $route.query.type === 'complaint'
              ">
              <el-upload
                class="upload-demo"
                action=""
                :auto-upload="false"
                :show-file-list="false"
                :http-request="() => {}"
                :on-change="onFileChanged"
                multiple
                :file-list="fileList"
              >
                <el-button
                  size="mini"
                  type="primary"
                >追加附件</el-button>
              </el-upload>
            </span>
          </p>
          <p class="order-describe-file">
            <span
              v-for="item in Attachments"
              :key="item.Id"
            >
              <a
                class="order-describe-file-content"
                :href="item.DownloadPath"
              >
                <i class="el-icon-paperclip"></i>&nbsp;
                {{ item.FileName }} &nbsp;
                <span class="color-gray">{{ item.FileSize2 }}</span>
              </a>
            </span>
          </p>
        </div>
        <div class="order-detail-boxshadow">
          <div class="order-detail-history">
            <OrderTimeLine :historyList="orderInfo.Records || []" />
          </div>
        </div>
      </div>
    </div>
    <!-- <div
      class="order-detail-tabs"
      :class="{
        open: isDetailOpen,
      }"
    >
      <div
        class="order-detail-top"
        @click="isDetailOpen = !isDetailOpen"
      >
        <i class="el-icon-arrow-up"></i>
      </div>
      <div class="order-detail-content">
        <van-tabs v-model="active">
          <van-tab title="基本信息">
            <div class="order-detail-list">
              <div class="order-detail-item">
                <span>
                  业务类型
                </span>
                <span>
                  {{ BasicData.CategoryName }}
                </span>
              </div>
              <div class="order-detail-item">
                <span>
                  业务分类
                </span>
                <span>
                  {{ BasicData.WorkTypeName }}
                </span>
              </div>
              <div class="order-detail-item">
                <span>
                  处理组
                </span>
                <span>
                  {{ orderInfo.ProcessGroupsAll.map(item => item.GroupName).join(',') }}
                </span>
              </div>
            </div>
          </van-tab>
          <van-tab title="操作历史">
            <div class="order-detail-history">
              <OrderTimeLine :historyList="orderInfo.Records" />
            </div>
          </van-tab>
        </van-tabs>
        <div class="order-detail-btn">
          <van-tabbar
            active-color="#7d7e80"
            :fixed="false"
          >
            <van-tabbar-item
              icon="chat-o"
              @click="openFormPopup(1)"
            >
              评论
            </van-tabbar-item>
            <van-tabbar-item
              icon="flag-o"
              @click="openFormPopup(2)"
            >处理</van-tabbar-item>
            <van-tabbar-item
              icon="friends-o"
              @click="addUserPopupShow = true"
            >添加处理人</van-tabbar-item>
          </van-tabbar>
        </div>
      </div>

    </div> -->
    <div
      class="order-detail-btn"
      v-if="
        orderInfo.IsUserCopy ||
        orderInfo.IsUserProcess ||
        orderInfo.IsUserSubmit
      "
    >
      <van-tabbar
        active-color="#7d7e80"
        :fixed="true"
      >
        <van-tabbar-item
          icon="chat-o"
          @click="openFormPopup(1)"
        >
          评论
        </van-tabbar-item>
        <van-tabbar-item
          icon="flag-o"
          @click="openFormPopup(2)"
        >处理</van-tabbar-item>
        <van-tabbar-item
          v-if="$route.query.type === 'normal'"
          icon="friends-o"
          @click="addUserPopupShow = true"
        >添加处理人</van-tabbar-item>
      </van-tabbar>
    </div>
    <van-popup
      v-model="formPopupShow"
      closeable
      position="bottom"
    >
      <div class="order-form">
        <el-form
          ref="form"
          :model="orderForm"
          :rules="orderFormRules"
          label-width="80px"
          size="mini"
        >
          <div v-if="BasicData.WorkType === 'lutong'">
            <el-form-item
              label="操作"
              prop="lutong_business_node_code"
            >
              <el-radio-group
                v-model="orderForm.lutong_business_node_code"
                @change="lutongNodeChange"
              >
                <el-radio
                  v-for="option in lvtongNodeList"
                  :key="option.key"
                  :label="option.key"
                  :disabled="option.disabled"
                >{{ option.value }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="服务商"
              prop="lutong_supplier"
            >
              <el-radio-group v-model="orderForm.lutong_supplier">
                <el-radio
                  v-for="option in lvtongSupplierList"
                  :key="option.key"
                  :label="option.key"
                  @change="lvtongSupplierChange"
                >{{ option.value }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="就诊医院"
              prop="lutong_hospital_name"
            >
              <el-input v-model="orderForm.lutong_hospital_name"></el-input>
            </el-form-item>
            <el-form-item
              label="就诊科室"
              prop="lutong_office_name"
            >
              <el-input v-model="orderForm.lutong_office_name"></el-input>
            </el-form-item>
            <el-form-item
              label="预约医生姓名"
              prop="lutong_doctor_name"
            >
              <el-input v-model="orderForm.lutong_doctor_name"></el-input>
            </el-form-item>
            <el-form-item label="医院所在城市">
              <el-input v-model="orderForm.lutong_business_hospital_city"></el-input>
            </el-form-item>
            <el-form-item
              label="预约就诊时间"
              prop="lutong_visite_time"
            >
              <el-input
                :value="orderForm.lutong_visite_time"
                placeholder="选择预约就诊时间"
                readonly
                @focus="lvtongChangeTime('lutong_visite_time')"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item
              label="首次响应时间"
              prop="lutong_first_response_time"
            >
              <el-input
                :value="orderForm.lutong_first_response_time"
                placeholder="选择首次响应时间"
                readonly
                @focus="lvtongChangeTime('lutong_first_response_time')"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="需求确认时间"
              prop="lutong_need_confirm_time"
            >
              <el-input
                :value="orderForm.lutong_need_confirm_time"
                placeholder="选择需求确认时间"
                readonly
                @focus="lvtongChangeTime('lutong_need_confirm_time')"
              ></el-input>
            </el-form-item> -->
            <van-popup
              v-model="showLvtongTimePicker"
              position="bottom"
            >
              <van-datetime-picker
                type="datetime"
                @confirm="onLvtongTimePickerConfirm"
                @cancel="showLvtongTimePicker = false"
                :min-date="moment().subtract(7, 'days').toDate()"
                :formatter="datetimePickerFormatter"
              />
            </van-popup>
            <el-form-item
              label="是否使用医保卡"
              prop="lutong_is_use_medical_insurance"
            >
              <el-radio-group v-model="orderForm.lutong_is_use_medical_insurance">
                <el-radio :label="'1'">是</el-radio>
                <el-radio :label="'2'">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="医保卡卡号"
              prop="lutong_insurance_num"
            >
              <el-input v-model="orderForm.lutong_insurance_num"></el-input>
            </el-form-item>
          </div>

          <el-form-item
            label="处理状态"
            v-if="BasicData.WorkType === 'sell_new'"
          >
            <el-radio-group v-model="orderForm.accept_status">
              <el-radio :label="3">审核完成</el-radio>
              <el-radio :label="4">审核退回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="record_type === 1 ? '添加评论' : '处理建议'">
            <el-input
              v-model="orderForm.record"
              type="textarea"
              :rows="2"
              placeholder="请填写处理建议"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否结案">
            <el-switch v-model="orderForm.close_status"></el-switch>
          </el-form-item>
          <el-form-item label="通知">
            <el-checkbox-group v-model="orderForm.notice_groups">
              <el-checkbox
                v-for="item in ProcessGroupsGlobal"
                :key="item.id"
                :label="item.Id"
                :value="item.Id"
              >{{ item.GroupName }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="">
            <el-button
              type="primary"
              :loading="orderFormSubmiting"
              @click="onSubmit"
            >提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </van-popup>
    <van-popup
      v-model="addUserPopupShow"
      position="bottom"
      closeable
      :style="{ height: '500px' }"
    >
      <!-- <el-drawer
  title=""
  :visible.sync="addUserPopupShow"
  direction="btt"> -->
      <div class="order-form add-form">
        <div v-if="isPhone">
          <van-search
            show-action
            placeholder="请输入搜索关键词"
            v-model="vanSearchValue"
            @search="remoteMethod"
          >
            <template #action>
              <div @click="remoteMethod(vanSearchValue)">搜索</div>
            </template>
          </van-search>
          <van-picker
            title=""
            show-toolbar
            cancel-button-text=""
            confirm-button-text="添加"
            :columns="addUserSearchList"
            value-key="showText"
            @confirm="addUserPhoneHandler"
          />
        </div>
        <el-select
          v-else
          v-model="addUserForm"
          filterable
          remote
          reserve-keyword
          :remote-method="remoteMethod"
          :loading="addUserLoading"
          value-key="Id"
          @change="addUserSelect"
          placeholder="请选择处理人"
          @hook:mounted="cancalReadOnly"
          @visible-change="cancalReadOnly"
          ref="select"
        >
          <el-option
            v-for="item in addUserSearchList"
            :key="item.Id"
            :label="item.UserName"
            :value="item"
          >
            <span style="float: left">{{ item.UserName }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{
              item.UserPosition
            }}</span>
          </el-option>
        </el-select>
        <div>
          <el-tag
            v-for="item in ProcessUsers"
            :key="item.UserId"
          >{{
            item.UserName
          }}</el-tag>
          <el-tag
            v-for="item in addUserList"
            :key="item.UserId"
            closable
            @close="addUserRemove(item)"
          >{{ item.UserName }}</el-tag>
        </div>
        <el-button
          type="primary"
          @click="addUserSubmit"
        >添加</el-button>
      </div>
      <!-- </el-drawer> -->
    </van-popup>
    <van-popup v-model="selectPopup.show">
      <div class="association">
        <div class="association-title">{{ selectPopup.title }}</div>
        <div
          class="association-search"
          v-show="selectPopup.type === 'association' || selectPopup.type === 'assignee'"
        >
          <form action="/">
            <van-search
              v-model="associationKeyword"
              :placeholder="selectPopup.type === 'association' ? '请搜索工单ID/描述/标题' : '请输入关键词'"
              @search="onSelectPopupSearch"
              show-action
            >
              <template #action>
                <el-button
                  size="small"
                  type="primary"
                  @click="onSelectPopupSearch(associationKeyword)"
                >搜索</el-button>
                <!-- <div @click="onAssociationSearch(associationKeyword)">搜索</div> -->
              </template>
            </van-search>
          </form>
        </div>
        <div class="association-radio">
          <el-radio-group v-model="selectPopup.value">
            <el-radio
              v-for="item in selectPopup.list"
              :key="item.Id"
              :label="item.Id"
            >{{ item.Title }}</el-radio>
          </el-radio-group>
          <el-input
            v-show="selectPopup.value == 99"
            :maxlength="50"
            v-model="selectPopup.other"
            label=""
            size="small"
            placeholder="请输入"
          ></el-input>
        </div>
        <div class="association-btn">
          <el-button
            size="small"
            type="primary"
            @click="onSelectPopupCancel"
          >取消</el-button>
          <el-button
            size="small"
            type="primary"
            @click="onSelectPopupSubmit"
          >确认</el-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="idPopupShow">
      <div class="association">
        <div class="association-radio">
          <van-form ref="idForm">
            <van-field
              readonly
              clickable
              name="picker"
              :value="idForm.id_type_name"
              label="证件类型"
              placeholder="点击选择证件类型"
              :rules="[{ required: true, message: '请选择证件类型' }]"
              @click="idTypePickerShow = true"
            />
            <van-popup
              v-model="idTypePickerShow"
              position="bottom"
              get-container=".order-detail"
            >
              <van-picker
                show-toolbar
                :columns="idTypeList"
                :default-index="idPickerDefaultIndex"
                @confirm="idTypeConfirm"
                @cancel="idTypePickerShow = false"
              />
            </van-popup>
            <van-field
              v-model="idForm.id_no"
              name="证件号"
              label="证件号"
              placeholder="证件号"
              :rules="[
                { required: true, message: '请填写证件号' },
                {
                  validator: checkIdCardNo,
                  message: '请填写正确的证件号',
                },
              ]"
            />
          </van-form>
        </div>
        <div class="association-btn">
          <el-button
            size="small"
            type="primary"
            @click="idPopupShow = false"
          >取消</el-button>
          <el-button
            size="small"
            type="primary"
            @click="onIdFormSubmit"
          >确认</el-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="fangaiEditShow">
      <fangaiEdit
        ref="fangaiEdit"
        :rightName="tagMap[BasicData.work_label]"
        :rightCode="BasicData.work_label"
        :userInfo="userInfo"
        @updateSuccess="fangaiUpdate"
      />
    </van-popup>
    <waisongTime ref="waisongTime" />
  </div>
</template>

<script>
import OrderTimeLine from "@/views/components/OrderTimeLine";
import workService from "@/apis/work/index.js";
import complaintService from "@/apis/complaint/index.js";
import getUserInfo from "@/models/userInfo";
import systemService from "@/apis/system/index.js";
import pd1Service from "@/apis/pd1/index.js";
import { Message } from "element-ui";
import { isPhone, isWeiXin } from "@/utils/utils";
import { getHisPatientEnums } from "@/models/customer";
import { Dialog } from "vant";
import idCardTool from "@/utils/idCard.js";
import complaintWorkInfo from "./components/complaintWorkInfo.vue";
import complaintWorkAction from "./components/complaintWorkAction.vue";
import contactPhone from "./components/contactPhone.vue";
import fangaiEdit from "./components/fangaiEdit.vue";
import waisongTime from "./components/waisongTime.vue";
import moment from "moment";

import { setStorageExpire, deepClone } from "@/utils/utils";

// import leXiang from "@/apis/leXiang/index.js";
const lvtongRules = {
  lutong_business_node_code: [
    {
      required: true,
      message: "请选择操作节点",
      trigger: "change",
    },
  ],
};

export default {
  data() {
    return {
      isPhone: isPhone(),
      isWeiXin: isWeiXin(),
      orderForm: {
        notice_groups: [],
      },
      addUserForm: {},
      addUserLoading: false,
      addUserSearchList: [],
      drawer: true,
      active: 0,
      formPopupShow: false,
      addUserPopupShow: false,
      orderInfo: {
        ProcessGroupsAll: [],
      },
      BasicData: {},
      ProcessUsers: [],
      SubmitUserInfo: {},
      isDetailOpen: true,
      fileList: [],
      userInfo: {},
      Attachments: [],
      ProcessGroupsGlobal: [],
      record_type: 0,
      addUserList: [],
      pickerColumns: [],
      vanSearchValue: "",
      hisPatientEnumsMap: {},
      pd1EnumsMap: {},
      selectPopup: {
        title: "",
        show: false,
        list: [],
        type: "",
        value: "",
      },
      associationShow: false,
      associationKeyword: "",
      associationList: [],
      idPopupShow: false,
      idTypePickerShow: false,
      idTypeList: [],
      idForm: {},
      idPickerDefaultIndex: 0,
      acceptGroupList: [],
      tagList: [],
      tagMap: {},
      fangaiEditShow: false,
      orderFormSubmiting: false,
      orderFormRules: {},
      showLvtongTimePicker: false,
      lvtongNodeList: [],
      lvtongSupplierList: [],
    };
  },
  name: "MWorkOrderDetail",
  components: {
    OrderTimeLine,
    complaintWorkInfo,
    complaintWorkAction,
    contactPhone,
    fangaiEdit,
    waisongTime,
  },
  async created() {},
  async mounted() {
    try {
      await this.init();
    } catch (e) {
      alert(e);
    }

    this.getHisPatientEnums();
    this.getPd1Service();
    await this.getLvtongList();

    this.workMyWorkDetail();
    this.workGetEnum();
    this.workGetAcceptGroupList();
    this.workLabelList();
  },
  methods: {
    moment,
    fangaiEdit() {
      this.fangaiEditShow = true;
      this.$nextTick(() => {
        this.$refs.fangaiEdit.fangaixianServiceDataSearch();
      });
    },
    workLabelList() {
      const params = {
        work_id: this.$route.query.id,
      };
      workService.workLabelList(params).then((res) => {
        const tagMap = {};
        res.forEach((item) => {
          item.Id = item.label_code;
          item.Title = item.label_name;
          tagMap[item.label_code] = item.label_name;
        });
        this.tagMap = tagMap;
        this.tagList = res;
      });
    },
    fangaiUpdate() {
      this.fangaiEditShow = false;
      this.workMyWorkDetail();
    },
    goCustomerStatus(type = "") {
      const { BasicData } = this;
      this.$router.push({
        name: "CustomerStatus",
        query: {
          menzhen_work_id_neijing:
            type === "neijing" ? BasicData.menzhen_work_id_neijing : "",
          menzhen_work_id_tijian:
            type === "tijian" ? BasicData.menzhen_work_id_tijian : "",
        },
      });
    },
    goCustomerLogs(type = "") {
      const { BasicData } = this;
      this.$router.push({
        name: "CustomerLogs",
        query: {
          menzhen_work_id_neijing:
            type === "neijing" ? BasicData.menzhen_work_id_neijing : "",
          menzhen_work_id_tijian:
            type === "tijian" ? BasicData.menzhen_work_id_tijian : "",
        },
      });
    },
    showIdForm() {
      const { BasicData, idTypeList } = this;
      let defaultIndex = 0;

      idTypeList.some((item, index) => {
        if (item.value === BasicData.kehu_id_type) {
          defaultIndex = index;
          return true;
        }
        return false;
      });
      this.idPickerDefaultIndex = defaultIndex;
      this.idForm = {
        id_type_name: BasicData.kehu_id_type_name || "",
        id_no: BasicData.kehu_id_no || "",
        id_type: BasicData.kehu_id_type || "",
      };
      this.idPopupShow = true;
    },
    workGetAcceptGroupList() {
      workService.workGetAcceptGroupList().then((res) => {
        this.acceptGroupList = res;
      });
    },
    workGetAcceptUserList() {
      const { BasicData } = this;
      const params = {
        group_id: BasicData.accept_group_id,
      };
      workService.workGetAcceptUserList(params).then((res) => {
        console.log(res);
      });
    },
    checkIdCardNo(value) {
      const { idForm } = this;
      if (idForm.id_type == "1" && !idCardTool.checkIdCardNo(value)) {
        return false;
      }
      if (idForm.id_type == "61" && value.length > 18) {
        return false;
      } else {
        return true;
      }
    },
    onIdFormSubmit() {
      this.$refs.idForm
        .validate()
        .then((res) => {
          const { idForm, userInfo } = this;
          const params = {
            work_id: this.$route.query.id,
            id_type: idForm.id_type,
            id_no: idForm.id_no,
            user_id: userInfo.user_id,
          };
          workService.workEditCustomerId(params).then(() => {
            Message({
              message: "修改成功",
              type: "success",
            });
            this.idPopupShow = false;
            this.workMyWorkDetail();
          });
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    workGetEnum() {
      workService.workGetEnum().then((res) => {
        let idTypeList = [];
        const { dicWorkIdType } = res;
        Object.keys(dicWorkIdType).forEach((key) => {
          idTypeList.push({
            text: dicWorkIdType[key],
            value: key,
          });
        });
        this.idTypeList = idTypeList;
      });
    },
    idTypeConfirm(item) {
      const { idForm } = this;
      idForm.id_type = item.value;
      idForm.id_type_name = item.text;
      this.idTypePickerShow = false;
    },
    contactClients() {
      const { BasicData, userInfo } = this;
      Dialog.confirm({
        title: "提示",
        message: "请确认是否联系客户？",
      })
        .then(() => {
          const params = {
            work_id: this.$route.query.id,
            to_user_id: "",
            to_user_name: BasicData.ContactName,
            to_user_phone: BasicData.ContactPhone,
            user_id: userInfo.user_id,
          };
          workService.WorkContactCustomer(params).then((res) => {
            console.log(res);
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    sendBack() {
      Dialog.confirm({
        title: "提示",
        message: "请确认是否退回至转发人？",
      })
        .then(() => {
          const { userInfo } = this;
          const params = {
            work_id: this.$route.query.id,
            user_id: userInfo.user_id,
          };
          workService.workRollback(params).then(() => {
            this.workMyWorkDetail();
            Message({
              message: "操作成功",
              type: "success",
            });
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    selectPopupShow(type) {
      const { selectPopup, acceptGroupList, BasicData, pd1EnumsMap } = this;
      if (type === "acceptanceGroup" && BasicData.accept_group_id) {
        Message({
          message: "已分配受理组。   只有大区总监退回后，可再分配。",
          type: "warning",
        });
        return;
      }
      selectPopup.show = true;
      selectPopup.type = type;
      selectPopup.value = "";
      if (type === "association") {
        selectPopup.title = "请选择关联工单";
        selectPopup.list = [];
      } else if (type === "acceptanceGroup") {
        selectPopup.title = "请选择受理组";
        selectPopup.list = acceptGroupList.map((item) => {
          item.Title = item.GroupName;
          return item;
        });
      } else if (type === "assignee") {
        selectPopup.title = "请选择受理人";
        const params = {
          group_id:
            BasicData.WorkType === "sell_new"
              ? "1037"
              : BasicData.accept_group_id,
        };
        workService.workGetAcceptUserList(params).then((res) => {
          selectPopup.list = res.map((item) => {
            item.Title = `${item.UserName} ${
              item.UserPosition ? item.UserPosition : ""
            } ${item.UserPhone}`;
            return item;
          });
          selectPopup.originList = deepClone(selectPopup.list);
        });
      } else if (type === "tag") {
        selectPopup.title = "请选择标签";
        selectPopup.list = this.tagList;
      } else if (type === "serviceType") {
        selectPopup.title = "请选择服务标签";
        selectPopup.list = pd1EnumsMap.service_labelArr.map((item) => {
          item.Title = item.name;
          item.Id = item.value;
          return item;
        });
      }
    },
    onSelectPopupCancel() {
      this.selectPopup.show = false;
    },
    onSelectPopupSubmit() {
      const { userInfo, BasicData, selectPopup } = this;

      if (!selectPopup.value) {
        Message({
          message: "请选择选项",
          type: "warning",
        });
        return;
      }
      if (selectPopup.type === "association") {
        const params = {
          work_id: BasicData.Id,
          ref_work_id: selectPopup.value,
          user_id: userInfo.user_id,
        };
        workService.WorkRelate(params).then(() => {
          selectPopup.show = false;
          this.workMyWorkDetail();
          Message({
            message: "关联成功",
            type: "success",
          });
        });
      } else if (selectPopup.type === "acceptanceGroup") {
        const { acceptGroupList } = this;
        let accept_group_name = "";
        acceptGroupList.some((item) => {
          if (item.Id == selectPopup.value) {
            accept_group_name = item.Title;
            return true;
          }
          return false;
        });
        const params = {
          work_id: BasicData.Id,
          accept_group_id: selectPopup.value,
          accept_group_name: accept_group_name,
          user_id: userInfo.user_id,
        };
        workService.workAssignAcceptGroup(params).then(() => {
          selectPopup.show = false;

          this.workMyWorkDetail();
          Message({
            message: "操作成功",
            type: "success",
          });
        });
      } else if (selectPopup.type === "assignee") {
        let currentItem = null;
        selectPopup.list.some((item) => {
          if (item.Id == selectPopup.value) {
            currentItem = item;
            return true;
          }
          return false;
        });
        const params = {
          work_id: BasicData.Id,
          user_id: userInfo.user_id,
          accept_user_id: currentItem.Id,
          accept_user_name: currentItem.UserName,
          accept_user_phone: currentItem.UserPhone,
          is_auto: 0,
        };
        workService.workAssignAcceptUser(params).then(() => {
          selectPopup.show = false;

          this.workMyWorkDetail();
          Message({
            message: "操作成功",
            type: "success",
          });
        });
      } else if (selectPopup.type === "tag") {
        let label = selectPopup.value;
        if (label == 99 && !selectPopup.other) {
          Message({
            message: "请输入标签",
            type: "warning",
          });
          return;
        }
        if (label == 99) label = selectPopup.other;

        const params = {
          work_id: BasicData.Id,
          user_id: userInfo.user_id,
          label,
        };
        workService.workLabel(params).then(() => {
          selectPopup.show = false;

          this.workMyWorkDetail();
          Message({
            message: "操作成功",
            type: "success",
          });
        });
      } else if (selectPopup.type === "serviceType") {
        let label = selectPopup.value;

        const params = {
          work_id: BasicData.Id,
          user_id: userInfo.user_id,
          label_key: label,
        };

        pd1Service.pd1WorkLabel(params).then(() => {
          selectPopup.show = false;

          this.workMyWorkDetail();
          Message({
            message: "操作成功",
            type: "success",
          });
        });
      }
    },
    onSelectPopupSearch(keyWord) {
      const { selectPopup } = this;
      if (selectPopup.type === "association") {
        this.onAssociationSearch(keyWord);
      } else if (selectPopup.type === "assignee") {
        this.onAssigneeSearch(keyWord);
      }
    },
    onAssigneeSearch(keyword) {
      const { selectPopup } = this;
      if (keyword.trim() === "") {
        Message({
          message: "输入关键词",
          type: "error",
        });
        return;
      }
      selectPopup.list = selectPopup.originList.filter((item) => {
        return item.Title.indexOf(keyword) !== -1;
      });
    },
    onAssociationSearch(keyword) {
      const { selectPopup } = this;
      if (keyword.trim() === "") {
        Message({
          message: "输入关键词",
          type: "error",
        });
        return;
      }
      const params = {
        keyword,
      };
      workService.workExtListSearch(params).then((res) => {
        // this.associationList = res
        res.forEach((item) => {
          item.Title = `${item.Id} ${item.Title}`;
        });
        selectPopup.list = res;
      });
    },
    goCallRecords() {
      this.$router.push({
        name: "WorkOrderCallRecords",
        query: {
          work_id: this.$route.query.id,
        },
      });
    },
    goPd1Rights(type) {
      const { BasicData } = this;
      let targetPageName = "";
      let query = {};
      if (type === "detail") {
        targetPageName = "Pd1Rights";
      } else if (type === "handbook") {
        targetPageName = "Pd1Handbook";
        let bookUrl =
          "https://circle-his.oss-cn-shanghai.aliyuncs.com/DataCenterPro/PD1/common/handbook.pdf";
        if (BasicData.pd1_card_channel === "tp") {
          bookUrl =
            "https://circle-his.oss-cn-shanghai.aliyuncs.com/DataCenterPro/PD1/common/pd_1_taiping.pdf";
        }
        if (BasicData.pd1_card_version === "垫付版") {
          bookUrl =
            "https://circle-his.oss-cn-shanghai.aliyuncs.com/DataCenterPro/PD1/common/handbook_dianfu.pdf";
        }
        if (BasicData.pd1_card_version.indexOf("安护版") !== -1) {
          bookUrl =
            "https://circle-his.oss-cn-shanghai.aliyuncs.com/DataCenterPro/PD1/common/handbook_anhu.pdf";
        }
        window.location.href = bookUrl;
        return;
        // query = {
        //   pd1_service_subtype: BasicData.pd1_card_version,
        // };
      } else if (type === "means") {
        targetPageName = "Pd1Means";
      } else if (type === "flow") {
        targetPageName = "Pd1Flow";
      } else if (type === "pharmacyMaintenance") {
        targetPageName = "Pd1PharmacyFinder";
        query = {
          maintain: true,
        };
      } else {
        targetPageName = type;
      }

      this.$router.push({
        name: targetPageName,
        query: {
          work_id: this.$route.query.id,
          service_id: BasicData.pd1_service_id,
          service_type: BasicData.pd1_service_type,
          ...query,
        },
      });
    },
    goRights() {
      const { BasicData } = this;

      this.$router.push({
        name: "WorkOrderRights",
        query: {
          id_type: BasicData.kehu_id_type,
          id_no: BasicData.kehu_id_no,
          id: this.$route.query.id,
        },
      });
      // if (!BasicData.kehu_id_no) {
      //   Message({
      //     message: "没有输入证件号",
      //     type: "warning",
      //   });
      //   return;
      // }
      // if (BasicData.ExternalType === "fangaixian") {
      //   const params = {
      //     work_id: this.$route.query.id,
      //   };
      //   leXiang.fangaixianLabelStatusSearch(params).then(() => {
      //     this.$router.push({
      //       name: "WorkOrderFangaiRights",
      //       query: {
      //         id: this.$route.query.id,
      //       },
      //     });
      //   });
      // } else {
      //   const params = {
      //     id_type: BasicData.kehu_id_type,
      //     id_no: BasicData.kehu_id_no,
      //   };
      //   workService.rightsByIdNo(params).then(() => {
      //     this.$router.push({
      //       name: "WorkOrderRights",
      //       query: {
      //         id_type: BasicData.kehu_id_type,
      //         id_no: BasicData.kehu_id_no,
      //       },
      //     });
      //   });
      // }
    },
    async init() {
      const { isWeiXin } = this;
      const query = this.$route.query;
      // query.source == 'datecenter' 为了兼容中台
      if (isWeiXin || query.source == "datecenter") {
        if (document.querySelector(".el-menu-yuanhe")) {
          document.querySelector(".el-menu-yuanhe").style.display = "none";
        }
        const ddUserInfoKey = "dd-user-info";

        this.userInfo = {
          user_id: query.userid,
        };
        setStorageExpire(ddUserInfoKey, this.userInfo, 60 * 24 * 7);
        return true;
      } else {
        const userInfo = await getUserInfo();
        this.userInfo = userInfo;
        return true;
      }
    },
    getHisPatientEnums() {
      getHisPatientEnums().then((res) => {
        this.hisPatientEnumsMap = res;
      });
    },
    getPd1Service() {
      pd1Service.pd1Enums().then((res) => {
        this.pd1EnumsMap = res;
      });
    },
    addUserSelect(value) {
      const { ProcessUsers } = this;
      if (
        ProcessUsers.some((item) => {
          return item.UserId === value.UserId;
        })
      ) {
        Message({
          message: "该用户已是处理人，请勿重复添加",
          type: "warning",
        });
      } else {
        this.addUserList.push(value);
        // this.ProcessUsers.push(value)
      }
    },

    addUserRemove(option) {
      console.log(option);
      this.addUserList = this.addUserList.filter(
        (item) => item.UserId !== option.UserId
      );
    },
    addUserPhoneHandler(value) {
      console.log(value);
      const { ProcessUsers } = this;
      if (
        ProcessUsers.some((item) => {
          return item.UserId === value.UserId;
        })
      ) {
        Message({
          message: "该用户已是处理人，请勿重复添加",
          type: "warning",
        });
      } else {
        this.addUserList.push(value);
        this.addUserSubmit();
        // this.ProcessUsers.push(value)
      }
    },
    addUserSubmit() {
      const { addUserList, userInfo, BasicData, isPhone } = this;
      if (addUserList.length === 0) {
        Message({
          message: "请选择需要添加的处理人",
          type: "warning",
        });
        return;
      }
      const params = {
        work_id: BasicData.Id,
        user_id: userInfo.user_id,
        users: addUserList.map((item) => item.UserId),
      };
      workService.workMyWorkDetailProcessUserAdd(params).then(() => {
        if (!isPhone) this.addUserPopupShow = false;
        this.addUserList = [];
        this.workMyWorkDetail();
      });
    },
    remoteMethod(query) {
      console.log(query);
      if (query !== "") {
        const params = {
          filter: query,
        };
        this.addUserLoading = true;
        workService.workMyWorkDetailProcessUserSearch(params).then((res) => {
          this.addUserLoading = false;
          res.forEach((user) => {
            user.showText = `${user.UserName}${
              user.UserPosition ? `(${user.UserPosition})` : ""
            }`;
          });
          this.addUserSearchList = res;
        });
      }
    },

    openFormPopup(record_type = 0) {
      const { BasicData } = this;
      this.$refs.form?.resetFields();
      this.orderForm = {
        close_status: this.orderInfo.IsClosed,
        notice_groups: [],
      };
      if (BasicData.WorkType === "lutong") {
        this.orderForm = {
          ...this.orderForm,
          ...this.orderInfo.LutongNodeStatus,
        };
      }
      this.record_type = record_type;
      this.formPopupShow = true;
    },
    async workMyWorkDetail() {
      const { userInfo } = this;
      const params = {
        work_id: this.$route.query.id,
        user_id: userInfo.user_id,
      };
      workService.workMyWorkDetail(params).then((res) => {
        res.BasicData.originWorkType = res.BasicData.WorkType;
        // 与绿通处理逻辑一样
        if (res.BasicData.originWorkType === "yky2") {
          res.BasicData.WorkType = "lutong";
        }
        this.orderInfo = res;
        if (
          res.BasicData.menzhen_work_id_tijian &&
          res.BasicData.menzhen_work_id_neijing
        ) {
          res.BasicData.customerStatusName = "体检+内镜状态";
        } else if (res.BasicData.menzhen_work_id_neijing) {
          res.BasicData.customerStatusName = "内镜状态";
        } else if (res.BasicData.menzhen_work_id_tijian) {
          res.BasicData.customerStatusName = "体检状态";
        }
        if (res.BasicData?.waisong_date) {
          res.BasicData.Notes = `
            ${res.BasicData.Notes}
            外送时间: ${res.BasicData.waisong_date}
          `;
        }
        if (res.BasicData?.Notes2) {
          res.BasicData.Notes = `
          ${res.BasicData.Notes}

          ${res.BasicData.Notes2}
            
          `;
        }
        if (res.BasicData.WorkType === "lutong") {
          this.orderFormRules = {
            ...lvtongRules,
          };
          if (res.LutongNodeStatus?.lutong_business_node_code) {
            this.lutongNodeChange(
              res.LutongNodeStatus.lutong_business_node_code
            );
          }
        }

        this.BasicData = res.BasicData;
        this.SubmitUserInfo = res.SubmitUserInfo;
        this.ProcessGroupsGlobal = res.ProcessGroupsGlobal;
        this.Attachments = res.Attachments || [];
        this.ProcessUsers = res.ProcessUsers || [];
        if (res.BasicData.CategoryId === 155) {
          this.$route.query.type = "complaint";
          this.getComplaintWorkDetail();
        } else {
          this.$route.query.type = "normal";
        }
      });
    },
    async getComplaintWorkDetail() {
      const { userInfo } = this;
      const params = {
        center_work_id: this.$route.query.id,
        user_id: userInfo.user_id,
      };
      complaintService.getWorkDetail(params).then((res) => {
        this.orderInfo = {
          ...this.orderInfo,
          ...res,
        };
        this.BasicData = {
          ...this.BasicData,
          ...res,
          SubmitTime2: res.SubmitTime,
          Notes: `
            姓名：${res.customer_name}
            电话：${res.customer_mobile}
            情况简述：
            ${res.complaint_remark}
          `,
          ContactPhone: res.customer_mobile,
          ContactName: res.customer_name,
        };

        this.SubmitUserInfo = {
          ...this.SubmitUserInfo,
          ...res,
        };

        console.log(res);
      });
    },
    onFileChanged(file, fileList) {
      this.$nextTick(() => {
        file.status = "uploading";
      });
      this.fileList = fileList;
      const formData = new FormData();
      formData.append("file", file.raw);
      const query = {
        file_type: "work",
        file_name: file.name,
        file_ext: file.name.split(".").pop(),
        file_size: file.size,
      };

      const onUploadProgress = (progressEvent) => {
        const percentage =
          (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
        file.percentage = percentage;
        this.$forceUpdate();
      };
      const loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      systemService.upload(formData, query, onUploadProgress).then((res) => {
        file.file_id = res.file_id;
        const params = {
          work_id: this.BasicData.Id,
          user_id: this.userInfo.user_id,
          files: [
            {
              file_id: res.file_id,
            },
          ],
        };
        workService
          .workMyWorkDetailFileAdd(params)
          .then(() => {
            loading.close();
            Message({
              message: "附件添加成功",
              type: "success",
            });
            this.workMyWorkDetail();
          })
          .catch(() => {
            loading.close();
            Message({
              message: "附件添加失败",
              type: "error",
            });
          });
      });
    },
    async onSubmit() {
      const {
        orderForm,
        BasicData,
        record_type,
        lvtongNodeList,
        orderFormRules,
        orderInfo,
      } = this;
      let errMsg = "";
      if (BasicData.WorkType === "sell_new") {
        if (!orderForm.accept_status) {
          Message({
            message: "请选择受理状态",
            type: "warning",
          });
          return;
        }
        this.orderFormSubmiting = true;

        await this.workAcceptStatusEdit();
      }
      // 绿通
      if (BasicData.WorkType === "lutong") {
        if (
          orderForm.lutong_business_node_code == "4" &&
          !orderForm.lutong_first_response_time
        ) {
          const currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
          orderForm.lutong_first_response_time = currentTime;
          orderForm.lutong_need_confirm_time = currentTime;
        }
        // 根据orderFormRules中的必填项进行校验，将errMsg赋值为必填项的提示信息
        Object.keys(orderFormRules).some((key) => {
          if (orderFormRules[key][0].required && !orderForm[key]) {
            errMsg = orderFormRules[key][0].message;
            return true;
          }
          return false;
        });
        if (
          orderInfo.LutongNodeStatus?.lutong_business_node_code &&
          orderForm.lutong_business_node_code > 4 &&
          orderForm.lutong_business_node_code <
            orderInfo.LutongNodeStatus?.lutong_business_node_code
        ) {
          errMsg = "当前节点不可回退";
        }

        if (orderForm.lutong_business_node_code) {
          lvtongNodeList.some((item) => {
            if (item.key === orderForm.lutong_business_node_code) {
              orderForm.lutong_business_node_name = item.value;
              return true;
            }
          });
        }
      }
      if (errMsg) {
        Message({
          message: errMsg,
          type: "warning",
        });
        return;
      }
      const params = {
        ...orderForm,
        work_id: BasicData.Id,
        user_id: this.userInfo.user_id,
        record_type,
        record: orderForm.record,
        close_status: orderForm.close_status ? 1 : 0,
        notice_groups: orderForm.notice_groups.join(","),
      };
      this.orderFormSubmiting = true;

      workService
        .workMyWorkDetailComment(params)
        .then(() => {
          this.formPopupShow = false;
          this.orderFormSubmiting = false;

          this.workMyWorkDetail();
          Message({
            message: "提交成功",
            type: "success",
          });
        })
        .catch(() => {
          this.orderFormSubmiting = false;
        });
    },
    workAcceptStatusEdit() {
      const { BasicData, orderForm } = this;
      const params = {
        row_guid: BasicData.RowGuid,
        accept_status: orderForm.accept_status,
        user_id: this.userInfo.user_id,
        user_name: this.userInfo.user_name,
      };
      return workService.workAcceptStatusEdit(params);
    },
    handleClose() {},
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    goDetail() {
      // this.$router.push({
      //   name: 'WorkOrderDetail',
      //   query: {
      //     ...this.$route.query,
      //     id,
      //   }
      // })
    },
    goAppDetails() {
      const { BasicData } = this;
      this.$router.push({
        name: "AppDetails",
        query: {
          ...this.$route.query,
          neijingId: BasicData.menzhen_work_id_neijing,
          tijianId: BasicData.menzhen_work_id_tijian,
        },
      });
    },
    showDeliveryTime() {
      this.$refs.waisongTime.show();
    },
    lvtongChangeTime(type) {
      this.lvtongTimePickerType = type;
      this.showLvtongTimePicker = true;
    },
    onLvtongTimePickerConfirm(time) {
      const { lvtongTimePickerType } = this;
      this.orderForm[lvtongTimePickerType] = moment(time).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.showLvtongTimePicker = false;
    },
    getLvtongList() {
      workService.getLutongNodeList().then((res) => {
        this.lvtongNodeList = res;
      });
      return workService.getLutongSupplierList().then((res) => {
        this.lvtongSupplierList = res;
      });
    },
    datetimePickerFormatter(type, val) {
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      if (type === "hour") {
        return val + "时";
      }
      if (type === "minute") {
        return val + "分";
      }
      return val;
    },
    lutongNodeChange(value) {
      if (value === "5") {
        this.orderFormRules = {
          lutong_hospital_name: [
            { required: true, message: "请选择就诊医院", trigger: "change" },
          ],
          lutong_office_name: [
            { required: true, message: "请选择就诊科室", trigger: "change" },
          ],
          lutong_doctor_name: [
            {
              required: true,
              message: "请选择预约医生姓名",
              trigger: "change",
            },
          ],
          lutong_visite_time: [
            {
              required: true,
              message: "请填写预约就诊时间",
              trigger: "change",
            },
          ],
        };
      } else if (value === "4") {
        this.orderFormRules = {
          lutong_first_response_time: [
            {
              required: true,
              message: "请填写首次相应时间",
              trigger: "change",
            },
          ],
          lutong_need_confirm_time: [
            {
              required: true,
              message: "请填写需求确认时间",
              trigger: "change",
            },
          ],
        };
      } else {
        this.orderFormRules = {};
      }
      this.orderFormRules = {
        ...this.orderFormRules,
        ...lvtongRules,
      };
      this.$refs.form && this.$refs.form.clearValidate();
    },
    lvtongSupplierChange(value) {
      const { lvtongNodeList, orderForm } = this;
      lvtongNodeList.forEach((item) => (item.disabled = false));
      if (value === "1") {
        lvtongNodeList.forEach((item) => {
          if (item.key !== "2" && item.key !== "3" && item.key !== "4") {
            item.disabled = true;
          }
        });
        if (
          orderForm.lutong_business_node_code !== "2" &&
          orderForm.lutong_business_node_code !== "3" &&
          orderForm.lutong_business_node_code !== "4"
        ) {
          orderForm.lutong_business_node_code = "";
        }
      }
      this.lvtongNodeList = [...lvtongNodeList];
    },
  },
};
</script>

<style lang="scss">
.order-detail {
  height: 100%;
  // background-color: #fff;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  .order-detail-info {
    // padding: 20px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }
  .order-detail-box {
    flex: 1;
    box-sizing: border-box;
    // padding-bottom: 120px;
    margin: 20px 0;
    padding: 0 20px;
    overflow-y: auto;
    padding-bottom: 20px;
  }
  .order-detail-boxshadow {
    box-shadow: 0 -0.125rem 0.9375rem 0 rgb(13 23 38 / 15%);
    padding: 5px 15px;
    border-radius: 5px;
    background-color: #fff;
    margin-bottom: 5px;
    font-size: 14px;
    position: relative;
    padding-bottom: 65px;
  }
  .order-detail-btn-waisong {
    position: absolute;
    bottom: 5px;
    right: 5px;
    display: flex;
    flex-direction: column;
    .el-button {
      margin-top: 10px;
    }
  }
  .order-detail-top {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    font-size: 26px;
    flex-shrink: 0;
    cursor: pointer;
    .el-icon-arrow-up {
      background-color: #eef1f9;
      height: 40px;
      width: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 50px;
      transition: all 0.3s;
    }
  }

  .order-detail-tabs {
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    position: absolute;
    left: 0;
    right: 0;
    // top: calc(100% - 120px);
    transition: all 0.3s;
    bottom: -480px;
    height: 600px;
    .van-tabs {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  }
  .order-detail-tabs.open {
    // top: 200px;
    bottom: 0;
    .el-icon-arrow-up {
      transform: rotateZ(180deg);
    }
  }

  .order-detail-content {
    border-radius: 16px 16px 0 0;
    background-color: #fff;
    box-shadow: 0 -0.125rem 0.9375rem 0 rgb(13 23 38 / 15%);
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: space-between;
    overflow: hidden;
  }
  .order-title {
    margin: 0;
    padding: 10px 20px;
  }
  .order-des {
    font-size: 12px;
    color: #b8c1d0;
    padding: 20px;
    padding-bottom: 0;
    display: block;
    padding-top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .order-tel {
    color: #409eff;
    // font-size: 20px;
    // padding: 0 20px;
    // margin-top: 10px;
    display: block;
  }
  .order-describe-value,
  .order-describe-key {
    // padding: 0 20px;
    white-space: pre-line;
    margin-top: 0;
    margin-bottom: 0;
    // display: flex;
    justify-content: space-between;
  }
  .order-describe-value {
    min-height: 50px;
    word-break: break-all;
    a {
      word-break: break-all;
    }
  }
  .order-describe-file {
    display: flex;

    flex-direction: column;
    // padding: 0 20px;
    margin: 0px 0;
    span {
      display: block;
      margin: 3px 0;
    }
  }
  .order-describe-file-content {
    color: #409eff;
    cursor: pointer;
    display: flex;
    align-items: center;
    line-height: 12px;
    word-break: break-all;
  }
  .order-detail-list {
    // padding: 20px;
  }
  .order-detail-item {
    display: flex;
    font-size: 14px;
    justify-content: space-between;
    border-bottom: 1px solid #e4e7ed;
    padding: 5px 0;
    color: #616e80;
    span:nth-child(1) {
      flex-shrink: 0;
      // width: 70%;
      flex: 1;
      min-width: 100px;
    }
  }
  .order-detail-history {
    // padding: 20px;
    box-sizing: border-box;
  }
  .order-form {
    padding: 50px 20px 10px 20px;
    display: flex;
    flex-direction: column;
  }
  .add-form {
    height: 400px;
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
    box-sizing: border-box;
    .el-tag {
      margin-right: 5px;
    }
  }
}
.el-tag {
  margin-bottom: 10px;
}
.order-item-connect {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .el-link {
    margin-left: 10px;
  }
  div {
    text-align: right;
  }
}
.association {
  width: 300px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .association-search {
    width: 100%;
  }
  .association-radio {
    width: 100%;
    min-height: 100px;
    max-height: 350px;
    overflow-y: scroll;
    .el-radio-group {
      display: flex;
      flex-direction: column;
      padding: 0 5px;
    }
    .el-radio {
      margin: 5px 0;
    }
  }
  .association-btn {
    margin-top: 20px;
  }
}
</style>

<style lang="scss">
.order-detail {
  .van-tabs__line {
    background-color: #409eff;
  }
  .van-tabs__wrap {
    flex-shrink: 0;
  }
  .van-tabs__content {
    flex: 1;
    overflow-y: auto;
  }
}
.order-form {
  .el-form-item {
    margin-bottom: 20px;
  }
  .van-cell {
    padding: 0;
  }
  .van-field__label--right {
    margin-right: 0;
    padding-right: 12px;
  }
  .el-radio {
    margin-bottom: 10px;
  }
}
.van-picker__cancel {
  height: 0;
  overflow: hidden;
}
.association-radio {
  .el-radio__label {
    white-space: break-spaces;
    position: absolute;
  }
}
.order-item-connect-pd1 {
  & > div {
    padding: 3px 0;
  }
}
</style>